import React, { useEffect, useState } from "react";
import apiService from "../../services/apiService";
import "./StockTransactions.css";

export default function StockTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [movements, setMovements] = useState([]);
  const [selectedInfo, setSelectedInfo] = useState({});

  useEffect(() => {
    loadTransactions();
  }, []);

  const loadTransactions = async () => {
    try {
      const data = await apiService.getStockTransactions();
      setTransactions(data);
    } catch (err) {
      console.error("Error loading transactions:", err);
    }
  };

  const fetchMovements = async (itemID, lotNumber) => {
    if (!itemID || !lotNumber) return; // ignore if missing

    const data = await apiService.getStockMovement(itemID, lotNumber);
    setMovements(data);
    setSelectedInfo({ itemID, lotNumber });
    setShowModal(true);
  };

  const filtered = transactions.filter(
    (row) =>
      row.ItemName?.toLowerCase().includes(search.toLowerCase()) ||
      row.CatalogNo?.toLowerCase().includes(search.toLowerCase()) ||
      row.Barcode?.toLowerCase().includes(search.toLowerCase()) ||
      row.LotNumber?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="transactions-container">
      <h1>Stock Transactions</h1>

      <input
        className="search-input"
        placeholder="Search item, catalog, barcode, lot..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="transactions-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Item</th>
            <th>Catalog #</th>
            <th>Lot #</th>
            <th>Barcode</th>
            <th>Qty Change</th>
            <th>Action</th>
            <th>Warehouse</th>
          </tr>
        </thead>

        <tbody>
          {filtered.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>No records found.</td>
            </tr>
          ) : (
            filtered.map((t) => (
              <tr
                key={t.TransactionID}
                onClick={() => fetchMovements(t.ItemID, t.LotNumber)}
                style={{ cursor: "pointer" }}
              >
                <td>{new Date(t.TransactionDate).toLocaleString()}</td>
                <td>{t.ItemName}</td>
                <td>{t.CatalogNo}</td>
                <td>{t.LotNumber}</td>
                <td>{t.Barcode}</td>
                <td>{t.ChangeQty}</td>
                <td className={`action-${t.Action.toLowerCase()}`}>{t.Action}</td>
                <td>{t.WarehouseName}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* ✅ Movement History Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h2>Movement History | Lot: {selectedInfo.lotNumber}</h2>

            <table className="transactions-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Action</th>
                  <th>Qty Change</th>
                  <th>Barcode</th>
                </tr>
              </thead>
              <tbody>
                {movements.length === 0 ? (
                  <tr><td colSpan="4" style={{ textAlign: "center" }}>No movements recorded.</td></tr>
                ) : (
                  movements.map((m, i) => (
                    <tr key={i}>
                      <td>{m.ActionDate}</td>
                      <td>{m.Action}</td>
                      <td>{m.ChangeQty}</td>
                      <td>{m.Barcode}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            <button className="close-btn" onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
